import {useEffect, useRef} from 'react';
import {useIntl} from 'react-intl';
import {connect} from 'react-redux'

import {message} from 'antd';

import {SUCCESS_MESSAGE} from '../../../sagas/notifications';
import './Notification.css'

message.config({
  duration: 5,
})

const Notification = ({notifications}) => {
  const intl = useIntl();
  const shownNotifications = useRef(new Set());

  useEffect(() => {
    notifications.notifications.forEach(notification => {
      if (notification.id && shownNotifications.current.has(notification.id)) {
        return;
      }
      const type = notification.type || SUCCESS_MESSAGE;
      message[type](intl.formatMessage({id: notification.message}));
      if (notification.id) {
        shownNotifications.current.add(notification.id);
      }
    });
  }, [notifications.notifications]);

  return null;
};

const mapStateToProps = state => ({
  notifications: state.notifications,
});

export default connect(mapStateToProps)(Notification);



